module.exports = __webpack_public_path__ + "img/msi_100.33437513.svg";